/**
 * creator:linhe
 * date:2019/05/29
 * class:引用ajax组件，将方法进行组织封装；
 */
import storage from './localStorage'; //引入本地缓存
import sv from './staticVariables'; //引入静态变量
import router from './router'; //引入静态变量
import vueAxios from 'axios'; //引入axios
import qs from 'qs'; //引入axios请求URL参数格式转换组件
import { Toast } from 'vant'; //引入Toast控制loading
vueAxios.defaults.withCredentials = true; //解决跨域问题
//创建axios实例
let instance = vueAxios.create({
  baseURL: sv.SERVER_URL,
  timeout: 300000,
  responseType: 'json',
  transformRequest: [
    function (data, headers) {
      //依自己的需求对请求数据进行处理
      if (!data) {
        return data;
      }
      //复杂实体
      if (typeof data === 'string') {
        //修改请求头部
        headers['post']['Content-Type'] = 'application/json; charset=UTF-8;Cache-Control=no-store';
        return data;
      } else {
        //修改请求头部
        headers['post']['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8;Cache-Control=no-store';
        // 将对象 序列化成URL的形式，以&进行拼接
        return qs.stringify(data);
      }
    }
  ],
  headers: { requestType: 'SERVER' }
});

//封装post和get请求
function fetch(url, auxiosmethod, param, isLoading, _config) {
  return new Promise((resolve, reject) => {
    param = !param ? {} : param;
    if (isLoading) {
      //开启loading
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: '加载中...'
      });
    }
    if (auxiosmethod === 'post') {
      //post请求
      instance
        .post(url, param, _config)
        .then(response => {
          if (isLoading) {
            //请求成功关闭loading
            setTimeout(function () {
              Toast.clear(true);
            }, 500);
          }
          if (response.data) {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch(error => {
          if (isLoading) {
            //请求成功关闭loading
            Toast.clear(true);
          }
          reject(error);
        });
    } else if (auxiosmethod === 'get') {
      //get请求
      instance
        .get(url, param,_config)
        .then(response => {
          if (isLoading) {
            //请求成功关闭loading
            setTimeout(function () {
              Toast.clear(true);
            }, 500);
          }
          console.log('toPayget',response);
          let param = url.split('?')[1];
          console.log('toPayget111',param);
          if(response.status === 200 && url.includes('api/index/test2')){
             router.push('/reportDetail?' + param, () => {});
          }
          if (response.data) {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch(error => {
          if (isLoading) {
            //请求成功关闭loading
            Toast.clear(true);
          }
          reject(error);
        });
    }
  });
}

//封装图片上传
function upload(url, param, isLoading) {
  return new Promise(resolve => {
    if (isLoading) {
      //开启loading
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: '上传中...'
      });
    }
    new Promise((res, rej) => {
      let userToken = storage.getJsonLocalStorageItem(sv.USER_TOKEN);
      if (userToken) {
        //token存在
        let timestamp = new Date().getTime(); //当前时间戳
        if (timestamp < userToken.tokenExpireTime) {
          //没过期
          res(userToken.token);
        } else {
          //过期了,重新获取
          let param = storage.getJsonLocalStorageItem(sv.USER_ACCOUNT);
          if (!param) {
            rej('账号密码不存在,返回登录页');
          } else {
            fetch('/auth/systemUser/login', 'post', param, false, {}).then(function (data) {
              if (data.code === 200) {
                let timestamp = new Date().getTime();
                storage.setJsonLocalStorageItem(sv.USER_TOKEN, {
                  token: data.data.token,
                  tokenExpireTime: timestamp + data.data.tokenExpireTime - 60000
                });
                res(data.data.token);
              }
            });
          }
        }
      } else {
        //token不存在,返回登录页
        rej('token不存在,返回登录页');
      }
    }).then(
      function (token) {
        let config = { headers: { 'Content-Type': 'multipart/form-data', 'Authorization': token } };
        vueAxios
          .post(sv.UPLOADING_URL + url, param, config)
          .then(response => {
            if (isLoading) {
              //请求成功关闭loading
              Toast.clear(true);
            }
            let code = response.data.code;
            if (code === 403) {
              //单点登录被踢,xxx
              router.push('/login', () => {});
            } else if (code === 401) {
              //被修改密码或权限,返回登录页
              router.push('/login', () => {});
            } else if (code === 402) {
              //token过期,xxx
              router.push('/login', () => {});
            }
            if (response.data) {
              resolve(response.data);
            }
          })
          .catch(error => {
            if (isLoading) {
              //请求成功关闭loading
              Toast.clear(true);
            }
            if (error.message.indexOf('timeout') !== -1) {
              // 判断请求异常信息中是否含有超时timeout字符串
              router.push('/502', () => {});
            } else {
              let status = error.response.status;
              if (status === 502) {
                router.push('/502', () => {});
              } else if (status === 500) {
                router.push('/500', () => {});
              } else if (status === 404) {
                router.push('/404', () => {});
              } else if (status === 403) {
                router.push('/403', () => {});
              } else if (status === 401) {
                router.push('/login', () => {});
              } else if (status === 503) {
                Toast('短时间内请求频繁,请稍后重试！');
              }
            }
          });
      },
      function (error) {
        window.console.log(error);
        if (isLoading) {
          //请求成功关闭loading
          Toast.clear(true);
        }
        router.push('/login', () => {});
      }
    );
  });
}

//axios请求拦截;(请求时加上token)
// instance.interceptors.request.use(config => {
//   if (config.url.indexOf('/auth') === -1) {
//     //不是登录加token
//     let userToken = storage.getJsonLocalStorageItem(sv.USER_TOKEN);
//     if (userToken.token) {
//       //token存在
//       let timestamp = new Date().getTime(); //当前时间戳
//       if (timestamp < userToken.tokenExpireTime) {
//         //没过期
//         config.headers['Authorization'] = userToken.token;
//         return config;
//       } else {
//         //过期了,重新获取
//         return new Promise(resolve => {
//           let param = storage.getJsonLocalStorageItem(sv.USER_ACCOUNT);
//           if (!param) {
//             resolve(config);
//           } else {
//             fetch('/auth/systemUser/login', 'post', param, false, {}).then(
//               function (data) {
//                 if (data.code === 200) {
//                   let timestamp1 = new Date().getTime();
//                   storage.setJsonLocalStorageItem(sv.USER_TOKEN, {
//                     token: data.data.token,
//                     tokenExpireTime: timestamp1 + data.data.tokenExpireTime - 60000
//                   });
//                   config.headers['Authorization'] = data.data.token;
//                 } else {
//                   router.push('/login', () => {});
//                 }
//                 resolve(config);
//               },
//               function (err) {
//                 window.console.log(err);
//                 resolve(config);
//               }
//             );
//           }
//         });
//       }
//     } else {
//       //token不存在,返回登录页
//       router.push('/login', () => {});
//       return config;
//     }
//   } else {
//     return config;
//   }
// });
//axios响应拦截;(根据状态码跳不同页面)
instance.interceptors.response.use(
  response => {
    let code = response.data.code;
    if (code === 403) {
      //单点登录被踢,xxx
      router.push('/login', () => {});
    } else if (code === 401) {
      //被修改密码或权限,返回登录页
      router.push('/login', () => {});
    } else if (code === 402) {
      //token过期,xxx
      router.push('/login', () => {});
    }
    return response;
  },
  error => {
    if (error.message.indexOf('timeout') !== -1) {
      // 判断请求异常信息中是否含有超时timeout字符串
      router.push('/502', () => {});
    } else {
      let status = error;
      console.log('返回状态',status)
      if (status === 502) {
        router.push('/502', () => {});
      } else if (status === 500) {
        router.push('/500', () => {});
      } else if (status === 404) {
        router.push('/404', () => {});
      } else if (status === 403) {
        router.push('/403', () => {});
      } else if (status === 401) {
        router.push('/login', () => {});
      } else if (status === 503) {
        Toast('短时间内请求频繁,请稍后重试！');
      }
    }
    return error;
  }
);
export default {
  /**
   * post请求
   * @param url 请求地址
   * @param param 请求参数(复杂实体要序列化)
   * @param isLoading 不开loading false,开loading true
   * @param _config 特殊请求更改请求头配置
   * @return {*}
   */
  post(url, param, isLoading, _config) {
    return fetch(url, 'post', param, isLoading, _config);
  },
  /**
   * get请求
   * @param url 请求地址
   * @param param 请求参数(复杂实体要序列化)
   * @param isLoading 不开loading false,开loading true
   * @return {*}
   */
  get(url, param, isLoading) {
    return fetch(url, 'get', param, isLoading);
  },

  /**
   * 上传文件
   * @param url 请求地址
   * @param param 请求参数(FormData类型)
   * @param isLoading 不开loading false,开loading true
   * @return {*}
   */
  upload(url, param, isLoading) {
    return upload(url, param, isLoading);
  }
};
